<template>
  <img class="ak-avatar" :width="size" :height="size" :src="imagePath" />
</template>

<script>
import { computed, defineComponent, onBeforeMount, ref } from 'vue'
import { generateAvatar } from '../../utils/avatarFullNameImage'
const defaultImage =
  'https://res.cloudinary.com/big-top/image/upload/' +
  'v1462528865/system-v2/avatars/default-avatar-profile.png'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-avatar size="50" :is-profile-image=true
   * image="'https://example.com/img.png"></ak-avatar>
   */
  name: 'AkAvatar',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description Controls the profile image class is applied
     */
    isProfileImage: Boolean,

    /**
     * @type {String}
     * @description Controls the output of the image path
     */
    image: {
      default: undefined,
      type: String,
    },

    /**
     * @type {Number}
     * @description Controls the size of the avatar
     */
    size: {
      type: Number,
      default: 36,
    },

    /**
     * @type {String}
     * @description Makes image from full name
     */
    string: {
      type: [String, Boolean],
      default: false,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const path = ref(null)
    const imagePath = computed(() => {
      if (path.value) return path.value
      const parts = [`${props.image ? props.image : defaultImage}`]
      return parts.join('')
    })

    onBeforeMount(() => {
      if (props.string && typeof props.string === 'string') {
        path.value = generateAvatar({
          string: props.string,
          height: 256,
          width: 256,
        })
      }
    })

    return {
      imagePath,
    }
  },
})
</script>
<style lang="scss">
.ak-avatar {
  border-radius: 50%;
  height: auto;
  max-width: 100%;
  vertical-align: middle;
  text-align: center;
  background-color: #fff;

  &-wrapper {
    position: relative;

    .ak-avatar-badge {
      position: absolute;
      top: 0;
      right: 0;
      border: 1px solid #fff;
      &--bottom-left {
        top: auto;
        right: auto;
        bottom: 0;
        left: 0;
      }
      &--bottom-right {
        top: auto;
        bottom: 0;
      }
      &--score {
        right: 0;
        border: 0;
        transform: translate(10px, -10px);
        box-shadow: 0 4px 10px 0 rgba(0,0,0,.25);
      }
    }
  }
}
</style>
